import { Navigate, useLocation } from 'react-router-dom'

import routes from '../routes.constants'

const PerformanceInsightsRedirect = () => {
  const location = useLocation()

  return <Navigate to={{ pathname: routes.performanceInsightsPage.global, search: location.search }} replace />
}

export default PerformanceInsightsRedirect
